(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["login"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
    
      window.setPage()
  });

  window.setPage = function(e = undefined){
    setTimeout(() => {
      console.log(window.location.href.indexOf("recover"))
      const loginForm = document.getElementById('loginForm')
      const recoverForm = document.getElementById('recoverForm')
      if (window.location.href.indexOf("recover") > -1) {
        // on recover page
        recoverForm.classList.remove('hidden')
        loginForm.classList.add('hidden')
      }else{
        // on login page
        recoverForm.classList.add('hidden')
        loginForm.classList.remove('hidden')
      }
    }, 300);

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vue-index-school-cone"] && !window.DesignMode) return;
  try {
    
  setTimeout(() => {
    document.getElementById('school-cone-section').classList.remove('hidden')
  }, 2000)

  } catch(e) { console.error(e); }
})();
})();
